module.exports = __webpack_public_path__ + "static/media/quality-assurance.18c11f57.svg";